import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './HeroSection';
import FeaturedHomes from './FeaturedHomes';
import FeaturedNeighborhoods from './FeaturedNeighborhoods';
import StatsSection from './StatsSection';
import WarrantySection from './WarrantySection';
import AssociationsSection from './AssociationsSection';

const Home: React.FC = () => {
  return (
    <div>
      <HeroSection />
      <StatsSection />
      <section className="section bg-light">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="mb-4">Our Homes</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Explore our thoughtfully designed home plans with beautiful elevations and endless possibilities for your dream home.
            </p>
          </div>
          <FeaturedHomes />
          <div className="text-center mt-10">
            <Link to="/homes" className="btn btn-outline">
              View All Home Plans
            </Link>
          </div>
        </div>
      </section>
      
      <FeaturedNeighborhoods />
      <WarrantySection />
      <AssociationsSection />
      {/* <Testimonials /> */}
    </div>
  );
};

export default Home; 